module.exports = {"id":"177712","name":"Kévin Monnet-Paquet","rating":"73","photo":"./data/images/photos/4/177712.png","club":{"name":"ASSE","logo":"./data/images/clubs/ASSE.png"},"positions":["MG","AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinMonnet-Paquet0.json
// module id = 2351
// module chunks = 0